var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleRoundTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2906_26283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#34A353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.64 7.28008C18.24 6.93008 17.63 6.93008 17.23 7.28008L10.01 14.5001L6.79004 11.2801C6.39004 10.8801 5.74004 10.8801 5.34004 11.2801C5.14004 11.4801 5.04004 11.7301 5.04004 12.0001C5.04004 12.2701 5.15004 12.5301 5.34004 12.7201L9.29004 16.6701C9.49004 16.8701 9.74004 16.9801 10.01 16.9801C10.28 16.9801 10.54 16.8701 10.73 16.6701L18.65 8.75008C18.85 8.55008 18.95 8.29008 18.95 8.03008C18.95 7.77008 18.84 7.50008 18.62 7.29008L18.64 7.28008Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2906_26283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRoundTickIcon);
export default __webpack_public_path__ + "static/media/circleRoundTickIcon.256eb9fbef8d31451a19078c0df07a5a.svg";
export { ForwardRef as ReactComponent };